import React from "react";

export default function ForecastFilters({
  search,
  onSearchChange,
  branchFilter,
  onBranchChange,
  branches,
  monthWindow,
  onMonthWindowChange,
  onExportExcel,
  onExportPdf,
  disabled,
}) {
  return (
    <div className="flex flex-wrap items-end gap-3 p-3 bg-white border border-gray-300 rounded-lg shadow-sm">
      <div className="flex flex-col gap-1 min-w-[180px] flex-1">
        <label className="text-xs font-semibold text-gray-600">Search item</label>
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Filter by item name…"
          className="text-sm border rounded px-2 py-1.5"
          disabled={disabled}
        />
      </div>

      <div className="flex flex-col gap-1 min-w-[140px]">
        <label className="text-xs font-semibold text-gray-600">Branch</label>
        <select
          value={branchFilter}
          onChange={(e) => onBranchChange(e.target.value)}
          className="text-sm border rounded px-2 py-1.5"
          disabled={disabled}
        >
          <option value="all">All branches</option>
          {branches.map((b) => (
            <option key={b} value={b}>
              {b}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-1 min-w-[140px]">
        <label className="text-xs font-semibold text-gray-600">History window</label>
        <select
          value={monthWindow}
          onChange={(e) => onMonthWindowChange(e.target.value)}
          className="text-sm border rounded px-2 py-1.5"
          disabled={disabled}
        >
          <option value="all">All months</option>
          <option value="6">Last 6 months</option>
          <option value="12">Last 12 months</option>
          <option value="24">Last 24 months</option>
        </select>
      </div>

      <button
        type="button"
        onClick={onExportExcel}
        disabled={disabled}
        className="text-sm px-3 py-1.5 bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-50"
      >
        Export Excel
      </button>
      <button
        type="button"
        onClick={onExportPdf}
        disabled={disabled}
        className="text-sm px-3 py-1.5 bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50"
      >
        Export PDF
      </button>
    </div>
  );
}
